module.exports = __webpack_public_path__ + "img/small.45069ad6.jpg";